
import {
  createCustomizedShow,
  uploadFile,
  endProductColorList,
  endProductColorDetail
} from '@/services/http';
import { Component, Vue } from 'vue-property-decorator';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { isValidPhone } from '@/tools/regexp';

@Component({
  components: {
    Header,
    Footer,
    BackTop
  }
})
export default class extends Vue {
  isVisible: boolean = false

  defaultValueData: any = null

  //  上传图片列表
  fileList: any[] = []

  // 单色多色标签详情
  detailsList: any[] = []

  // 打印内容图片id
  customizContent: string = ''

  //  是否已经上传最大数量图片
  maxpic: boolean = false

  currentIndex: number = 0

  colorItem: string = ''

  infor: any = {}

  // 手机号码
  mobile: string = ''

  // 留言
  remark: string = ''

  // colorStr
  colorStr: string = ''

  listData: any[] = []

  options: any[] = [
    {
      value: '选项1',
      label: '黄金糕'
    },
    {
      value: '选项2',
      label: '双皮奶'
    },
    {
      value: '选项3',
      label: '蚵仔煎'
    },
    {
      value: '选项4',
      label: '龙须面'
    },
    {
      value: '选项5',
      label: '北京烤鸭'
    }
  ]

  value: string = ''

  created() {
    this.getColorList();
  }

  // 上传图片
  private async uploadpic(event: any) {
    const file = [...event.target.files];
    if (this.fileList.length < 5) {
      const uploadlength = 5 - this.fileList.length;
      const form = new FormData();
      file.forEach((value) => {
        form.append('fileData', value);
        form.append('type', '11');
      });
      const res: any = await uploadFile(form);
      if (res.data.code === 100) {
        this.fileList = [
          ...this.fileList,
          ...res.data.data.slice(0, uploadlength)
        ];
        if (this.fileList.length === 5) {
          this.maxpic = true;
        }
        this.customizContent = this.fileList.map((e) => e.id).join(',');
      } else {
        this.$message.error(res.data.message);
      }
    }
    // eslint-disable-next-line no-param-reassign
    event.target.value = '';
  }

  private removefile(index: number) {
    this.fileList.splice(index, 1);
    this.maxpic = false;
  }

  async getColorList() {
    const res: any = await endProductColorList({
      companyId: 1
    });
    this.infor = res.data.data;
    this.colorItem = res.data.data.blankLabelName;
    this.selectColor();
  }

  selectTag(index: number, name: string) {
    this.currentIndex = index;
    this.colorItem = name;
    this.selectColor();
  }

  // 选择颜色数量
  async selectColor() {
    const res: any = await endProductColorDetail({
      lableType: this.currentIndex,
      companyId: 1
    });
    if (this.currentIndex === 1) {
      const arr = res.data.data.colorList.map((value: any) => ({
        label: value.id,
        value: value.color
      }));
      this.listData = arr;
    }
    this.detailsList = res.data.data.detailList;
  }

  showViewer() {
    const viewer = (this as any).$refs.images.$viewer;
    viewer.show();
  }

  async next() {
    if (this.mobile === '') {
      this.$message.error('请输入手机号码');
    } else if (!isValidPhone(this.mobile)) {
      this.$message.error('请输入正确的手机号码！');
    } else {
      const {
        materialName,
        size,
        orderNum,
        packageTypeName,
        rowTypeName,
        directionTypeName,
        cornerTypeName,
        materialId,
        diameter
      } = this.$route.query;
      createCustomizedShow({
        mobile: this.mobile,
        materialName,
        size,
        orderNum,
        packageTypeName,
        rowTypeName,
        directionTypeName,
        cornerTypeName,
        customizContent: this.customizContent,
        colorStr: this.colorStr,
        remark: this.remark,
        materialId,
        diameter,
        colorItem: this.colorItem,
        companyId: 1
      });
      this.$router.push('/erial-success');
    }
  }
}
